export default {
	methods: {
		geraTrechoPessoa(item, trecho) {
			window.bus.$emit('load-in', {
				text: this._traducao('global', 'carregando')
			})
			let list = []
			for (let indexFormTrecho in trecho) {
				// add todos os trechos com está false
				list.push({...trecho[indexFormTrecho], esta: false})

				// faz um for nos trechos salvos no banco, pra verificar se o trechos do usuario está esse trecho
				for (let indexTrecho in item.trecho) {
					if (Number(item.trecho[indexTrecho].trecho) == Number(indexFormTrecho) + 1) {
						list[indexFormTrecho] = {
							...list[indexFormTrecho],
							...item.trecho[indexTrecho],
							esta: true
						}
					}
				}
			}
			window.bus.$emit('load-out')
			return list
		}
	}
}
